import React, {forwardRef} from 'react';

import {twx} from '@/utils/tailwindUtils';

const Input = forwardRef((props, ref) => {
    const {
        type,
        className,
        value,
        maxLength,
        minLength,
        onChange,
        placeholder,
        testId,
        'aria-labelledby': ariaLabelledby,
        id,
        ...rest
    } = props;

    return (
        <input
            ref={ref}
            className={twx(
                'block h-13 w-full appearance-none rounded-[2px] border border-solid border-primary-dark-25 bg-transparent bg-none pl-3 text-start text-16 text-primary outline-[0] placeholder-shown:overflow-hidden placeholder-shown:text-ellipsis focus:border-primary',
                className
            )}
            data-testid={testId}
            id={id}
            maxLength={maxLength}
            minLength={minLength}
            onChange={onChange}
            placeholder={placeholder}
            type={type}
            value={value}
            aria-labelledby={ariaLabelledby}
            {...rest}
        />
    );
});

Input.displayName = 'Input';

export default Input;
